const partDetailsSelection = `recordingPartDiagnostics {
  preprocess { expectedParts succeeded failed pending unreported known }
  recompose { expectedParts succeeded failed pending unreported known }
  anotherOrientationPending wholeFileCoverageVerified
}`;
const { partialOutcomeSelection } = require('./recordingPartialOutcome');

const showRecordingPartDetails = (role, flag = process.env.REACT_APP_RECORDING_PART_DETAILS_CUSTOMER_VISIBLE) =>
  role === 'admin' || flag === 'true';

// Read-only schema compatibility, never retries a mutation or an authorization error.
const legacyRecordingPartDetailsRequest = (request, response) => {
  if (typeof request?.query !== 'string' || !/^\s*query RecordingsSpecific\b/.test(request.query) ||
      !Array.isArray(response?.errors) || !response.errors.length) return null;
  let diagnosticsMissing = false, partialMissing = false;
  for (let errorIndex = 0; errorIndex < response.errors.length; errorIndex += 1) {
    const error = response.errors[errorIndex];
    if (/^Cannot query field "recordingPartDiagnostics" on type "Room"\./.test(error?.message || '') && request.query.includes(partDetailsSelection)) diagnosticsMissing = true;
    else if (/^Cannot query field "partialOutcome" on type "Recording"\./.test(error?.message || '') && request.query.includes(partialOutcomeSelection)) partialMissing = true;
    else return null;
  }
  // Keep this shared CommonJS helper free of CRA's ESM object-spread helper.
  let query = request.query;
  if (diagnosticsMissing) query = query.replace(partDetailsSelection, '');
  if (partialMissing) query = query.replace(partialOutcomeSelection, '');
  return Object.assign({}, request, { query });
};
module.exports = { partDetailsSelection, showRecordingPartDetails, legacyRecordingPartDetailsRequest };
